import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const SheetEventListPage = () =>
  import('@modules/sheet-event/components/sheet-event-list-page.vue');
const SheetEventFormPage = () =>
  import('@modules/sheet-event/components/sheet-event-form-page.vue');
const SheetEventViewPage = () =>
  import('@modules/sheet-event/components/sheet-event-view-page.vue');
const SheetEventImporterPage = () =>
  import('@modules/sheet-event/components/sheet-event-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'sheetEvent',
        path: '/sheet-event',
        component: SheetEventListPage,
        meta: {
          auth: true,
          permission: Permissions.values.sheetEventView,
        },
      },
      {
        name: 'sheetEventNew',
        path: '/sheet-event/new',
        component: SheetEventFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.sheetEventCreate,
        },
      },
      {
        name: 'sheetEventImporter',
        path: '/sheet-event/import',
        component: SheetEventImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.sheetEventImport,
        },
      },
      {
        name: 'sheetEventEdit',
        path: '/sheet-event/:id/edit',
        component: SheetEventFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.sheetEventEdit,
        },
        props: true,
      },
      {
        name: 'sheetEventView',
        path: '/sheet-event/:id',
        component: SheetEventViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.sheetEventView,
        },
        props: true,
      },
    ],
  },
];
